import { render } from "./QRCodeItem.vue?vue&type=template&id=1962aaa1&scoped=true"
import script from "./QRCodeItem.vue?vue&type=script&lang=js"
export * from "./QRCodeItem.vue?vue&type=script&lang=js"

import "./QRCodeItem.vue?vue&type=style&index=0&id=1962aaa1&scoped=true&lang=css"

import exportComponent from "/home/jenkinsx/workspace/build-dc-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1962aaa1"]])

export default __exports__